export default __webpack_public_path__ + "static/media/logo.9df19141.png";